import React from 'react'
import {Close} from 'assets/icons'
import Button from '../../button'
import 'styles/main.scss'

const Modalheader = ({children,hide,hideShow}) => {

    return (
        <div className="flex items-start justify-between gap-3 px-6 pt-5 pb-0.5 rounded-t">
            <h3 className="ft-lg tab:ft-2xl text-[#202124] font-semibold my-auto">
                {children}
            </h3>
            {hideShow ?
                <Button
                    size={'TABLE'}
                    color={'TABLE'}
                    onClick={hide}
                >
                    <Close wh={20} color={'#374151'} />
                </Button>
                : ''}
        </div>
    )
}

export default Modalheader